import React from "react";
import { Navigate } from "react-router-dom";
import { checkAdminRole, checkOper_or_admin } from "../utils/tool";

export function AdminRoute({ children }) {
  return checkAdminRole() ? children : <Navigate to="/booking" replace />;
}

export function OperOrAdminRoute({ children }) {
  return checkOper_or_admin() ? children : <Navigate to="/booking" replace />;
}
